import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Archive } from "../../../@types/archive";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

const createArchive = createAsyncThunk(
  "userAuthenticated/createArchive",
  async (file: any, { getState, rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const { data: archiveCreated } = await axiosInstance.post(`${api.baseURL}archive`, formData);

      const state = getState() as RootState;
      await axiosInstance.patch(`${api.baseURL}user/${state.userAuthentication.user?.id}`, {
        profilePicture: archiveCreated.id,
      });

      return archiveCreated as Archive;
    } catch (error:any) {
      const {message} = error
      rejectWithValue(message);
      throw message;
    }
  }
);

export default createArchive;
